<template>
  <!--      Header section start -->
  <WelcomeHeader />
  <!--      Header section end -->

  <SubMenu :title="title"></SubMenu>

  <section class="au-wrap">
    <div class="au-container">

      <!-- Intro -->
      <div class="au-intro">
        <span class="au-badge">কোম্পানি পরিচিতি</span>
        <h1 class="au-title">বিসিএস প্রস্তুতি</h1>
        <p class="au-lead">
          ৯ লাখ+ চাকরি প্রত্যাশীর আস্থা — বিসিএস, ব্যাংক, প্রাইমারি, শিক্ষক নিবন্ধন (NTRCA)
          সহ সকল সরকারি চাকরির প্রস্তুতির একটি স্মার্ট অনলাইন প্ল্যাটফর্ম।
          <strong>বিসিএস প্রস্তুতি</strong> অ্যাপটি পরিচালিত হয় <strong>Codeminers IT Limited</strong> কর্তৃক।
        </p>
      </div>

      <!-- Company card -->
      <div class="au-card">
        <div class="au-card-head">
          <a href="https://codeminersit.com/" target="_blank" rel="noopener" aria-label="Codeminers IT Limited">
            <img :src="require('@/assets/companylogo/Logo.svg')" alt="Codeminers IT Limited" class="au-logo" />
          </a>
        </div>

        <ul class="au-info">
          <li class="au-info-row">
            <span class="au-info-icon">
              <svg viewBox="0 0 24 24" fill="none"><path d="M3 21h18M5 21V7l7-4 7 4v14M9 9h.01M9 13h.01M9 17h.01M15 9h.01M15 13h.01M15 17h.01" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </span>
            <div class="au-info-text">
              <span class="au-info-label">Name</span>
              <span class="au-info-value">Codeminers IT Limited</span>
            </div>
          </li>

          <li class="au-info-row">
            <span class="au-info-icon">
              <svg viewBox="0 0 24 24" fill="none"><path d="M12 21s7-5.5 7-11a7 7 0 1 0-14 0c0 5.5 7 11 7 11z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><circle cx="12" cy="10" r="2.5" stroke="currentColor" stroke-width="1.7"/></svg>
            </span>
            <div class="au-info-text">
              <span class="au-info-label">Address</span>
              <span class="au-info-value">22-23 Station Road, Tejgaon; Tejgaon PS; Dhaka-1215</span>
            </div>
          </li>

          <li class="au-info-row">
            <span class="au-info-icon">
              <svg viewBox="0 0 24 24" fill="none"><rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.7"/><path d="m4 7 8 6 8-6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </span>
            <div class="au-info-text">
              <span class="au-info-label">Email</span>
              <a class="au-info-value au-link" href="mailto:admin@codeminersit.com">admin@codeminersit.com</a>
            </div>
          </li>

          <li class="au-info-row">
            <span class="au-info-icon">
              <svg viewBox="0 0 24 24" fill="none"><path d="M6.5 4h3l1.5 4-2 1.5a11 11 0 0 0 5 5l1.5-2 4 1.5v3a2 2 0 0 1-2.2 2A16 16 0 0 1 4.5 6.2 2 2 0 0 1 6.5 4z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>
            </span>
            <div class="au-info-text">
              <span class="au-info-label">Phone</span>
              <span class="au-info-value">
                <a class="au-link" href="tel:+8801313899797">01313899797</a>
                <span class="au-sep">|</span>
                <a class="au-link" href="tel:+8801715561961">01715561961</a>
              </span>
            </div>
          </li>

          <li class="au-info-row">
            <span class="au-info-icon">
              <svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.7"/><path d="M3 12h18M12 3c2.5 2.5 3.5 6 3.5 9s-1 6.5-3.5 9c-2.5-2.5-3.5-6-3.5-9S9.5 5.5 12 3z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>
            </span>
            <div class="au-info-text">
              <span class="au-info-label">Website</span>
              <a class="au-info-value au-link" href="https://codeminersit.com" target="_blank" rel="noopener">codeminersit.com</a>
            </div>
          </li>

          <li class="au-info-row">
            <span class="au-info-icon">
              <svg viewBox="0 0 24 24" fill="none"><path d="M7 3h7l5 5v13a0 0 0 0 1 0 0H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M14 3v5h5M9 13l2 2 4-4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </span>
            <div class="au-info-text">
              <span class="au-info-label">Trade License No</span>
              <span class="au-info-value">253310</span>
            </div>
          </li>
        </ul>
      </div>

    </div>
  </section>

  <WelcomeFooter />

</template>
<script>
import {defineComponent, onMounted, ref} from "vue";
import SubMenu from "@/components/SubMenu.vue";
import WelcomeHeader from "@/components/WelcomePages/WelcomeHeader.vue";
import WelcomeFooter from "@/components/WelcomePages/WelcomeFooter.vue";

export default defineComponent({
  components: {WelcomeHeader, SubMenu, WelcomeFooter},
  setup() {
    const title = ref(null)
    onMounted(() => {
      title.value = "আমাদের সম্পর্কে"
    });

    return {
      title,
    };
  },
})
</script>
<style scoped>
.au-wrap {
  background: #f4f7fb;
  padding: 56px 16px 72px;
  min-height: 60vh;
}
.au-container {
  max-width: 760px;
  margin: 0 auto;
}

/* Intro */
.au-intro {
  text-align: center;
  margin-bottom: 36px;
}
.au-badge {
  display: inline-block;
  font-family: "Noto Sans Bengali", sans-serif;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: #0066CC;
  background: rgba(0, 149, 255, 0.12);
  border: 1px solid rgba(0, 149, 255, 0.28);
  padding: 5px 16px;
  border-radius: 50px;
  margin-bottom: 16px;
}
.au-title {
  font-family: "Noto Sans Bengali", sans-serif;
  font-size: clamp(1.7rem, 4vw, 2.3rem);
  font-weight: 800;
  color: #191b47;
  margin-bottom: 14px;
  letter-spacing: -0.01em;
}
.au-lead {
  font-family: "Noto Sans Bengali", sans-serif;
  font-size: 1rem;
  font-weight: 500;
  color: #475569;
  line-height: 1.8;
  margin: 0 auto;
  max-width: 640px;
}
.au-lead strong { color: #191b47; font-weight: 700; }

/* Company card */
.au-card {
  background: #ffffff;
  border: 1px solid #e6ecf5;
  border-radius: 22px;
  box-shadow: 0 12px 40px rgba(25, 27, 71, 0.07);
  overflow: hidden;
}
.au-card-head {
  background: linear-gradient(135deg, #EAF4FF 0%, #f4f8fd 100%);
  padding: 38px 24px;
  text-align: center;
  border-bottom: 1px solid #e6ecf5;
}
.au-logo {
  max-width: 300px;
  width: 80%;
  height: auto;
}

/* Info list */
.au-info {
  list-style: none;
  margin: 0;
  padding: 8px 0;
}
.au-info-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 18px 28px;
  border-bottom: 1px solid #eef2f8;
}
.au-info-row:last-child { border-bottom: none; }

.au-info-icon {
  flex-shrink: 0;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 149, 255, 0.1);
  color: #0095FF;
}
.au-info-icon svg { width: 22px; height: 22px; }

.au-info-text {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding-top: 2px;
  min-width: 0;
  text-align: left;
}
.au-info-label {
  font-family: "Inter", system-ui, sans-serif;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94a3b8;
}
.au-info-value {
  font-family: "Noto Sans Bengali", "Inter", sans-serif;
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.5;
  word-break: break-word;
}
.au-link {
  color: #0095FF;
  text-decoration: none;
  transition: color 0.18s ease;
}
.au-link:hover { color: #0066CC; text-decoration: underline; }
.au-sep { color: #cbd5e1; margin: 0 8px; font-weight: 400; }

@media (max-width: 560px) {
  .au-wrap { padding: 36px 14px 52px; }
  .au-info-row { padding: 16px 18px; gap: 13px; }
  .au-card-head { padding: 30px 20px; }
  .au-info-value { font-size: 0.95rem; }
}
</style>
